'use client'

import {
  EHomeCategoryTab,
  HomePageConstants,
} from '@/app/(home)/_components/constants'
import { Button } from '@/components/ui/button'

type Props = {
  onChangeTab: (tab: EHomeCategoryTab) => void
  selectedTab: EHomeCategoryTab
}

export const FilterButton: React.FC<Props> = ({ onChangeTab, selectedTab }) => {
  return (
    <nav
      className='flex justify-start gap-4'
      role='navigation'
      aria-label='Category filters'
    >
      {HomePageConstants.categoryTabs.map((tab) => (
        <Button
          key={tab.key}
          size='large'
          variant={selectedTab === tab.key ? 'black' : 'neutral'}
          onClick={() => onChangeTab(tab.key)}
          data-tracking-level-3={tab.name}
          className='px-6 py-3 max-lg:h-9 max-lg:py-2 max-lg:text-sm'
          aria-pressed={selectedTab === tab.key}
          aria-label={`Filter by ${tab.name}`}
        >
          <span>{tab.name}</span>
        </Button>
      ))}
    </nav>
  )
}
